export default __webpack_public_path__ + "a0dfd0ef6348fc3df56bc83d6774a647.png";